'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.profilesDataRequested = profilesDataRequested;
exports.profilesDataReceived = profilesDataReceived;
exports.profilesDataRequestFailed = profilesDataRequestFailed;
exports.profilesUpdateSucceeded = profilesUpdateSucceeded;
var PROFILES_DATA_REQUESTED = exports.PROFILES_DATA_REQUESTED = 'PROFILES_DATA_REQUESTED';

function profilesDataRequested() {
    return {
        type: PROFILES_DATA_REQUESTED
    };
}

var PROFILES_DATA_RECEIVED = exports.PROFILES_DATA_RECEIVED = 'PROFILES_DATA_RECEIVED';

function profilesDataReceived(newProfilesData) {
    return {
        type: PROFILES_DATA_RECEIVED,
        newProfilesData: newProfilesData
    };
}

var PROFILES_DATA_REQUEST_FAILED = exports.PROFILES_DATA_REQUEST_FAILED = 'PROFILES_DATA_REQUEST_FAILED';

function profilesDataRequestFailed(error) {
    return {
        type: PROFILES_DATA_REQUEST_FAILED,
        error: error
    };
}

var PROFILES_UPDATE_SUCCEEDED = exports.PROFILES_UPDATE_SUCCEEDED = 'PROFILES_UPDATE_SUCCEEDED';

function profilesUpdateSucceeded(updatedProfiles) {
    return {
        type: PROFILES_UPDATE_SUCCEEDED,
        updatedProfiles: updatedProfiles
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/profilesDataActions.js
// module id = 153
// module chunks = 0